import Autoplay from 'embla-carousel-autoplay'
import { useRef } from 'react'
import CardServicosCompacto from './cardServicosCompacto'
import {
  Carousel,
  CarouselButtonsMobile,
  CarouselContent,
  CarouselItem,
} from './carousel'
import Container from './container'

export default function CardsFinops({ title, description, cards = [] }) {
  const scrollRef = useRef(null)

  return (
    <div className="w-full bg-[#040116] py-6 md:py-18">
      <Container className="text-white space-y-8">
        <h2 className="font-inter-light text-center text-2xl lg:text-5xl mb-8 md:px-12">
          {title}
        </h2>
        <p className="font-inter-regular text-sm md:text-xl text-center mb-8 md:mb-16 px-4 md:px-36">
          {description}
        </p>
        <div className="hidden md:grid md:grid-cols-3 md:gap-8 md:pb-8 md:px-4">
          {cards.map((card, index) => (
            <div key={index} className="flex justify-center">
              <CardServicosCompacto
                key={`desktop-${index}`}
                title={card.title}
                text={card.text}
                icon={card.icon}
                iconHover={card.iconHover || card.icon}
                glowColor={card.glowColor || '#FC0021'}
                iconBgColor="#11112E"
                origin="finops"
                width="350"
                height="220"
                className="mx-auto"
              />
            </div>
          ))}
        </div>
        <div ref={scrollRef} className="md:hidden">
          <Carousel
            plugins={[
              Autoplay({
                delay: 4000,
              }),
            ]}
            className="overflow-visible"
          >
            <CarouselContent className="py-2">
              {cards.map((card, index) => (
                <CarouselItem key={index}>
                  <div className="flex justify-center w-full">
                    <CardServicosCompacto
                      key={index}
                      title={card.title}
                      text={card.text}
                      icon={card.icon}
                      iconHover={card.iconHover || card.icon}
                      glowColor={card.glowColor || '#FC0021'}
                      width="350"
                      height="216"
                      iconBgColor="#11112E"
                      origin="finops"
                      className="mx-auto scale-92"
                    />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselButtonsMobile />
          </Carousel>
        </div>
      </Container>
    </div>
  )
}
